import React from 'react';
import {
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import {
  Brightness4 as DarkModeIcon,
  Brightness7 as LightModeIcon,
  SettingsBrightness as AutoModeIcon,
} from '@mui/icons-material';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = ({ showLabel = false }) => {
  const { isDarkMode, setThemeMode, resetToSystemTheme } = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThemeChange = (mode) => {
    if (mode === 'auto') {
      resetToSystemTheme();
    } else {
      setThemeMode(mode);
    }
    handleClose();
  };

  const currentMode = localStorage.getItem('pims-theme-manual') 
    ? (isDarkMode ? 'dark' : 'light') 
    : 'auto';

  return (
    <>
      <Tooltip title="Change theme">
        <IconButton
          onClick={handleClick}
          color="inherit"
          sx={{
            borderRadius: showLabel ? 2 : '50%',
            px: showLabel ? 2 : 1,
          }}
        >
          {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
          {showLabel && (
            <Typography variant="body2" sx={{ ml: 1 }}>
              {isDarkMode ? 'Light Mode' : 'Dark Mode'}
            </Typography>
          )}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 180,
          },
        }}
      >
        <MenuItem 
          onClick={() => handleThemeChange('light')}
          selected={currentMode === 'light'}
        >
          <ListItemIcon>
            <LightModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Light Mode</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={() => handleThemeChange('dark')}
          selected={currentMode === 'dark'}
        >
          <ListItemIcon>
            <DarkModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Dark Mode</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={() => handleThemeChange('auto')}
          selected={currentMode === 'auto'}
        >
          <ListItemIcon>
            <AutoModeIcon fontSize="small" />
          </ListItemIcon>
          <Box>
            <ListItemText>System Default</ListItemText>
            <Typography variant="caption" color="text.secondary">
              Follow system preference
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ThemeToggle;